import { Action } from "redux";
import api from "../../api";
import { MenuItem } from "../../typings/typings";
import { AppThunk } from "..";

export const UPDATE_ROUTE_ITEMS = "UPDATE_ROUTE_ITEMS";

export interface UpdateRouteItemsAction extends Action
{
    type: typeof UPDATE_ROUTE_ITEMS;
    routeItems: MenuItem[];
}

export const updateRouteItemsAction = (routeItemsFromApi: MenuItem[]) =>
{
    const action: UpdateRouteItemsAction = {
        type: UPDATE_ROUTE_ITEMS,
        routeItems: routeItemsFromApi
    };
    return action;
};

export const thunkUpdateRouteItems = (): AppThunk => async (dispatch) =>
{
    const response = await api.umbracoClient.getMenu();

    dispatch(updateRouteItemsAction(response));
};

export type RouteActions = UpdateRouteItemsAction;